import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase.config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import metalogo from "../Assets/metaverselogo.jpg";

const Navbar = (props) => {
  const [profileImageUrl, setProfileImageUrl] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const id = props.id
    ? props.id
    : localStorage.getItem("userid")?.replace(/"/g, "");

  useEffect(() => {
    const fetchProfileImage = async () => {
      if (id) {
        try {
          const userDocRef = doc(db, "users", id);
          const userDocSnap = await getDoc(userDocRef);

          if (userDocSnap.exists()) {
            const userData = userDocSnap.data();
            setProfileImageUrl(
              userData.profileImageUrl || "https://i.pravatar.cc/32"
            );
          }
        } catch (error) {
          console.error("Error fetching profile image:", error);
          setProfileImageUrl("https://i.pravatar.cc/32");
        }
      }
    };

    fetchProfileImage();
  }, [id]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="bg-gradient-to-r from-gray-900 to-black text-white py-4 px-8 xl:py-6 xl:px-16">
      <div className="container mx-auto flex justify-between items-center">
        <div className="flex items-center space-x-8 xl:space-x-12">
          <img
            src={metalogo}
            alt="MetaLogo"
            className="h-10 w-10 xl:h-16 xl:w-16"
          />
          <ul
            className={`flex space-x-6 xl:space-x-10 text-sm xl:text-lg hidden lg:flex`}
          >
            <li>
              <Link to="/" className="hover:text-gray-300">
                Home
              </Link>
            </li>
            <li>
              <Link to="/about" className="hover:text-gray-300">
                About
              </Link>
            </li>
            <li>
              <Link to="/members" className="hover:text-gray-300">
                Members
              </Link>
            </li>
            <li>
              <Link to="/attendance" className="hover:text-gray-300">
                Attendance
              </Link>
            </li>
          </ul>
        </div>
        <div className="flex items-center space-x-6 xl:space-x-10">
          <button onClick={toggleMenu} className="lg:hidden">
            <FontAwesomeIcon
              icon={isOpen ? faTimes : faBars}
              className="text-white"
            />
          </button>
          <div className="hidden lg:flex">
            {id ? (
              <>
                <Link
                  to={`/user/${id}`}
                  className="w-8 h-8 xl:w-12 xl:h-12 bg-gray-600 rounded-full overflow-hidden"
                >
                  <img
                    src={profileImageUrl}
                    alt="Avatar"
                    className="w-full h-full object-cover"
                  />
                </Link>
                <Link
                  to="/login"
                  onClick={() => {
                    localStorage.removeItem("userid");
                  }}
                  className="bg-gradient-to-r from-green-400 to-blue-500 text-black px-4 py-2 xl:px-6 xl:py-3 rounded-full font-bold hover:opacity-90 transition-opacity"
                >
                  Logout
                </Link>
              </>
            ) : (
              <Link
                to="/login"
                className="bg-gradient-to-r from-green-400 to-blue-500 text-black px-4 py-2 xl:px-6 xl:py-3 rounded-full font-bold hover:opacity-90 transition-opacity"
              >
                Login
              </Link>
            )}
          </div>
        </div>
      </div>
      {isOpen && (
        <div className="lg:hidden">
          <ul className="flex flex-col space-y-4 text-sm xl:text-lg px-8 py-4">
            <li>
              <Link to="/" className="hover:text-gray-300" onClick={toggleMenu}>
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className="hover:text-gray-300"
                onClick={toggleMenu}
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="/members"
                className="hover:text-gray-300"
                onClick={toggleMenu}
              >
                Members
              </Link>
            </li>
            <li>
              <Link to="/attendance" className="hover:text-gray-300">
                Attendance
              </Link>
            </li>
            {id ? (
              <>
                <Link
                  to={`/user/${id}`}
                  className="hover:text-gray-300 flex items-center space-x-2"
                  onClick={toggleMenu}
                >
                  <img
                    src={profileImageUrl}
                    alt="Avatar"
                    className="w-8 h-8 rounded-full"
                  />
                  <span>Profile</span>
                </Link>
                <Link
                  to="/login"
                  onClick={() => {
                    localStorage.removeItem("userid");
                    toggleMenu();
                  }}
                  className="bg-gradient-to-r from-green-400 to-blue-500 text-black px-4 py-2 rounded-full font-bold hover:opacity-90 transition-opacity"
                >
                  Logout
                </Link>
              </>
            ) : (
              <Link
                to="/login"
                onClick={toggleMenu}
                className="bg-gradient-to-r from-green-400 to-blue-500 text-black px-4 py-2 rounded-full font-bold hover:opacity-90 transition-opacity"
              >
                Login
              </Link>
            )}
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
